import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { User } from 'src/app/shared/models/security/user';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllUsers(): Observable<User[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userUrl}s`,
			'getAllUsers'
		);
	}

	getAllUsersForMessaging(): Observable<User[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.messageUrl}/users`,
			'getAllUsersForMessaging'
		);
	}

	getAllExistingConversations(): Observable<Conversation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userConvUrl}`,
			'getAllExistingConversations'
		);
	}

	getUserById(userId: number): Observable<User> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userUrl}/${userId}`,
			'getUserById'
		);
	}

	addUser(user: User): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.areaUrl}`,
			`addUser`,
			user
		);
	}

	updateUser(user: User): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.userUrl}`,
			`updateUser`,
			user
		);
	}

	deleteUser(userId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.userUrl}/${userId}`,
			`deleteUser`
		);
	}

	retrievePassword(email: string): Observable<void> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userUrl}/forgotPassword/${email}`,
			'retrievePassword'
		);
	}
}
